import Cookies from 'js-cookie'

const TokenKey = 'ccm-token'

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token,{ expires: 1/8});
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js